// src/pages/SalesLedger/components/SalesLedgerFilters.js
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, Row, Col, Button } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { setFilters } from "../SalesLedgerSlice";
import { fetchSalesLedger, fetchSaleAccounts } from "../SalesLedgerThunk";
import SearchListAutoComplete from "../../../components/SearchListAutoComplete";
import RecordDateFilter from "../../../components/filters/RecordDateFilter";
import CommonDateRangeFilter from "../../../components/common/filters/CommonDateRangeFilter";
import { useDefaultDateRange } from "../../../hooks/useDefaultDateRange";

const SalesLedgerFilters = ({ messageApi }) => {
  const dispatch = useDispatch();
  const { filters, accounts } = useSelector((state) => state.salesLedger);

  useDefaultDateRange(setFilters, filters, "today");

  useEffect(() => {
    dispatch(fetchSaleAccounts());
  }, [dispatch]);

  const handleFilterChange = (field, value) => {
    dispatch(setFilters({ [field]: value }));
  };

  const handleReport = () => {
    if (!filters.accId) {
      messageApi.warning("Select Account");
      return;
    }

    dispatch(fetchSalesLedger({ filters })).then((res) => {
      if (res.meta.requestStatus === "fulfilled") {
        messageApi.success("Report loaded ✅");
      } else {
        messageApi.error("Failed to fetch records ❌");
      }
    });
  };

  return (
    <Card className="mb-4 shadow-md rounded-xl">
      <Row gutter={[16, 16]} align="middle">
        {/* Account Search */}
        <Col xs={24} sm={12} md={12} lg={6}>
          <label>Search Account</label>
          <SearchListAutoComplete
            optionsList={accounts.map((c) => ({
              sale_id: c.acc_id,
              display_text: c.acc_name,
            }))}
            onSelect={(obj) => handleFilterChange("accId", obj?.sale_id)}
            placeholder="Account"
            showAddNew={false}
          />
        </Col>

        {/* Date Filter */}
        <CommonDateRangeFilter
          filters={filters}
          onChange={(fromDate, toDate) => {
          handleFilterChange("fromDate", fromDate);
          handleFilterChange("toDate", toDate);
          }}
        />

        {/* Report Button */}
        <Col xs={24} sm={12} md={12} lg={4}>
          <Button
            type="primary"
            icon={<SearchOutlined />}
            onClick={handleReport}
            block
            style={{ marginTop: 22 }}
          >
            Report
          </Button>
        </Col>
      </Row>
    </Card>
  );
};

export default SalesLedgerFilters;
